export default "__VITE_ASSET__BEnrZY$P__"